/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popMineLucky.vue?vue&type=template&id=88db39c2&scoped=true"
import script from "./popMineLucky.vue?vue&type=script&lang=js"
export * from "./popMineLucky.vue?vue&type=script&lang=js"
import style0 from "./popMineLucky.vue?vue&type=style&index=0&id=88db39c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88db39c2",
  null
  
)

export default component.exports